// removed by extract-text-webpack-plugin
module.exports = {"image":"c-ProductImage__image","imageLink":"c-ProductImage__imageLink","noClickable":"c-ProductImage__noClickable"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/ProductImage/ProductImage.scss
// module id = 509
// module chunks = 0